var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExcelicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3799_14658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8684 21.2718H7.41103C5.13283 21.2718 3.2793 19.4183 3.2793 17.1401V15.7535H5.18483V17.1401C5.18483 18.3675 6.18364 19.3663 7.41103 19.3663H15.8684C17.0958 19.3663 18.0946 18.3675 18.0946 17.1401V4.85976C18.0946 3.63237 17.0958 2.63356 15.8684 2.63356H7.41103C6.18364 2.63356 5.18483 3.63237 5.18483 4.85976V5.57691H3.2793V4.85976C3.2793 2.58156 5.13283 0.728027 7.41103 0.728027H15.8684C18.1466 0.728027 20.0001 2.58156 20.0001 4.85976V17.1401C20.0001 19.4183 18.1466 21.2718 15.8684 21.2718Z",
    fill: "#2AC14E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7448 13.7344H12.6152V15.3193H16.7448V13.7344Z",
    fill: "#2AC14E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56668 4.30615H1.40505C0.629401 4.30615 0 4.93555 0 5.7112V15.7914C0 16.567 0.629401 17.1964 1.40505 17.1964H9.56668C10.3423 17.1964 10.9717 16.567 10.9717 15.7914V5.7112C10.9706 4.93555 10.3423 4.30615 9.56668 4.30615ZM8.66428 12.809L7.54306 13.9302L5.48478 11.872L3.4265 13.9302L2.30528 12.809L4.36356 10.7507L2.30528 8.69246L3.4265 7.57124L5.48478 9.62952L7.54306 7.57124L8.66428 8.69246L6.606 10.7507L8.66428 12.809Z",
    fill: "#2AC14E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7448 9.41504H12.6152V10.9999H16.7448V9.41504Z",
    fill: "#2AC14E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7456 5.57715H14.2681V7.16203H16.7456V5.57715Z",
    fill: "#2AC14E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3799_14658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20.5438,
    fill: "white",
    transform: "translate(0 0.728027)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelicon);
export default __webpack_public_path__ + "static/media/excel icon.fbe465641dddb1377c64982cbdcb4388.svg";
export { ForwardRef as ReactComponent };